import 'view/css/form.css';
import React, { useState, useEffect, useRef } from 'react';

import Form from 'component/Form';
import Auth from 'service/auth';

const LoginView = () =>
{
  const [login_name, setLoginName] = useState('');
  const [password,   setPassword ] = useState('');
  const [error,      setError    ] = useState('');

  const ref_ln = useRef();

  useEffect(() =>
  {
    ref_ln.current.focus();
  }, []);

  const login = (e) =>
  {
    e.stopPropagation();
    e.preventDefault();

    let btn = e.target.querySelector('#btn-submit');
    btn.disabled = true;

    Auth.login(login_name, password).then(resp =>
    {
      if (!resp.success)
        setError(resp.error);
      else
      {
        let l = window.location;
        window.location.href = `${l.protocol}//${l.host}/`;
      }
      btn.disabled = false;
    });
    return false;
  }

  return (
    <div id="login-frame" className="centre-all">
      <h1>登入系統</h1>
      <Form className="x-form login" onSubmit={login} useEnter>
        <label className="search-field">
          <strong>登入名稱</strong>
          <input type="text" value={login_name} required pattern="[a-z0-9]{2,16}"
                  placeholder="使用者登入系統的登入名稱" title="2至16個字母或數字" ref={ref_ln}
                  onChange={e=>setLoginName(e.target.value.trim().toLowerCase())}
                  autoComplete="username" />
        </label>
        <label className="search-field">
          <strong>密碼</strong>
          <input type="password" value={password} required pattern=".{6,}"
                  placeholder="最少6個字元的登入密碼" title="最少6個字元" autoComplete="current-password"
                  onChange={e=>setPassword(e.target.value)} />
        </label>
        <div>
          <button id="btn-submit" className="btn blue">登入</button>
        </div>
        {
          !!error &&
          <div>
            <span className="error-msg">{ error }</span>
          </div>
        }
      </Form>
    </div>
  );
}

export default LoginView;